import { useSession } from '@common/hooks';
import { ProtectionLevel } from '@router/types';

export const useProtectionLevels = (
    requiredProtectionLevel: ProtectionLevel,
) => {
    const { protectionLevel } = useSession();

    const areAllLevelsMet =
        (protectionLevel & requiredProtectionLevel) === requiredProtectionLevel;

    return areAllLevelsMet;
};
